import { render, staticRenderFns } from "./PluginAlert.vue?vue&type=template&id=3777087d"
import script from "./PluginAlert.vue?vue&type=script&lang=js"
export * from "./PluginAlert.vue?vue&type=script&lang=js"
import style0 from "./PluginAlert.vue?vue&type=style&index=0&id=3777087d&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3777087d')) {
      api.createRecord('3777087d', component.options)
    } else {
      api.reload('3777087d', component.options)
    }
    module.hot.accept("./PluginAlert.vue?vue&type=template&id=3777087d", function () {
      api.rerender('3777087d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plugin/PluginAlert.vue"
export default component.exports